import { Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { BaryCtaMenuService } from '../../../../services/bary-cta-menu.service';
import { CtaAction } from '../../../../models/cta.action';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-cta',
  standalone: true,
  templateUrl: './bary-cta.component.html',
  styleUrls: ['./bary-cta.component.scss'],
  imports: [MDBBootstrapModulesPro, BaryIconComponent],
})
export class BaryCtaComponent {
  readonly #baryCtaMenuService = inject(BaryCtaMenuService);

  @Input() public actions: CtaAction[] = [];
  @Input() public idCypress: string = '';

  @Output() public selectAction = new EventEmitter<any>();

  @ViewChild('ctaBtn') private ctaBtn!: ElementRef;

  protected readonly FAS = FaDirectiveEnum.FAS;

  public onClick(event: any): void {
    event.preventDefault();
    event.stopPropagation();

    this.#baryCtaMenuService.showCtaMenu(this.actions, this.ctaBtn.nativeElement, { textRight: true });
    this.#baryCtaMenuService.onContextMenuItemClick?.subscribe(it => {
      this.selectAction.next(it);
    });
  }
}
